import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import BaseAPI from '../../api/apiurl';

const ApexPWeekly = () => {
  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: []
      }
    },
    series: [
      {
        name: "service_count",
        data: []
      }
    ]
  });

  useEffect(() => {
    const fetchData = async () => {
      const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');
      try {
        const response = await fetch(
          `${BaseAPI}serviceuserchart?company_id=${company_id}&customer_id=${customer_id}`
        );
        const data = await response.json();

        const categories = data.data.map((item) => item.username);
        const serviceCount = data.data.map((item) => item.service_count);

        setChartData({
          options: {
            chart: {
              id: "basic-bar"
            },
            xaxis: {
              categories: categories
            }
          },
          series: [
            {
              name: "service_count",
              data: serviceCount
            }
          ]
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            width="500"
          />
        </div>
      </div>
    </div>
  );
};

export default ApexPWeekly;
